export const ON_WIDGET_LOAD_COMPLETE = 'onWidgetLoadComplete'
export const ON_COOKIES_CONSENT = 'termlyConsent'
